<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { routeTitle } from "@/lang";
export default {
  data() {
    return {};
  },
  mounted() {
    this.listenerResize();
    this.$nextTick(() => {
      this.banCtrlMouseWheel();
      window.addEventListener("resize", this.listenerResize, false);
    });
  },
  computed: {
    pageTitle() {
      const route = this.$route;
      if (route.name === "login") return this.$t("login.login_btn");
      if (route.name === "resetPwd") {
        return this.$t(route.query.mode === "voluntary" ? "resetPwd.voluntary_title" : "resetPwd.force_title");
      }
      if (route.name === "index") return this.$t("nav.platform_name");
      if (route.name === "404") return this.$t("public.not_found_title");
      return routeTitle(route);
    },
  },
  watch: {
    pageTitle: {
      handler(value) { document.title = value; },
      immediate: true,
    },
    $route: {
      handler(route) {
        if (route.name === "login") return;
        const isConfig = route.matched.some(item => item.name === "receiver" || item.name === "status");
        this.$store.commit("config/SET_MODEL", isConfig ? "config" : "");
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listenerResize() {
      this.$store.dispatch("config/getDeviceInfo");
    },
    banCtrlMouseWheel() {
      window.addEventListener(
        "mousewheel",
        function (event) {
          if (event.ctrlKey === true || event.metaKey) {
            event.preventDefault();
          }
        },
        { passive: false }
      );

      //firefox
      window.addEventListener(
        "DOMMouseScroll",
        function (event) {
          if (event.ctrlKey === true || event.metaKey) {
            event.preventDefault();
          }
        },
        { passive: false }
      );
    },
  },
};
</script>
<style>
* {
  /* touch-action: none; */
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #2c3e50; */
  height: 100%;
  background-color: #e6e7ea;
  /* background-color: $main_color; */
}

.container {
  height: 100%;
}
</style>
